import React from 'react';

const billingAdminHome = React.lazy(
  () =>
    import(
      'src/latest/src/features/billing-admin/billing-admin-home/BillingAdminMain'
    ),
);

const PatientDetailsPage = React.lazy(
  () =>
    import(
      'src/latest/src/features/billing-admin/patient-details/PatientDetails'
    ),
);


export const billingAdminRoutes = [
  {
    path: 'home',
    name: 'BillingAdminHome',
    component: billingAdminHome,
    extact: true,
  },
  {
    path: 'client-details/:clientId',
    name: 'ClientDetails',
    component: PatientDetailsPage,
    exact: true,
  }
];
